/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialActivityDetailResponse } from '../../models/editorial-activity-detail-response';

export interface GetEditorialActivity$Params {
  id: number;
  culture: string;
}

export function getEditorialActivity(http: HttpClient, rootUrl: string, params: GetEditorialActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialActivityDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, getEditorialActivity.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('culture', params.culture, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditorialActivityDetailResponse>;
    })
  );
}

getEditorialActivity.PATH = '/api/editorial/activities/{id}';
